import React from 'react';
import { TransparentButton } from '../ClickableComponents/Button';
import { jsx as _jsx } from "react/jsx-runtime";
export const MenuButton = ({
  title,
  onClick,
  icon,
  fontSize,
  isDisabled
}) => /*#__PURE__*/_jsx(TransparentButton, {
  type: "text",
  text: title,
  onClick: onClick,
  icon: icon,
  fontSize: fontSize,
  leftAligned: true,
  isDisabled: isDisabled
});